import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';
import {
  AZURE_SSO_SESSION_KEY,
  MICROSOFT_SESSION_USER_KEY,
} from '../auth/authSessionKeys';
import api from './api';

// User Create Account
export const userAccountCreate = createAsyncThunk(
  'userCreate',
  async (data) => {
    const userCreate = await api.post('register', data);
    if (userCreate.status === 201) {
      localStorage.setItem('access_token', userCreate.data.access);
      localStorage.setItem('refresh_token', userCreate.data.refresh);
      let decoded = jwtDecode(userCreate.data.access);
      return { status: userCreate.status, userResponse: decoded };
    }

    return userCreate;
  }
);

export const updateInfo = createAsyncThunk('updateInfo', async () => {
  const userToken = localStorage.getItem('access_token');
  if (!userToken) {
    return {};
  }

  let decoded = {};
  try {
    decoded = jwtDecode(userToken) || {};
  } catch {
    decoded = {};
  }

  const isAzureSso = localStorage.getItem(AZURE_SSO_SESSION_KEY) === '1';
  const snapshot = localStorage.getItem(MICROSOFT_SESSION_USER_KEY);
  if (!snapshot && !isAzureSso) {
    return decoded;
  }

  let storedUser = {};
  if (snapshot) {
    try {
      storedUser = JSON.parse(snapshot) || {};
    } catch {
      storedUser = {};
    }
  }

  // JWT claims for identity; SSO sessions skip forced password-change gate
  return {
    ...storedUser,
    ...decoded,
    user_id: decoded.user_id ?? storedUser.user_id,
    email: decoded.email ?? storedUser.email,
    role: decoded.role ?? storedUser.role,
    first_name: decoded.first_name ?? storedUser.first_name,
    last_name: decoded.last_name ?? storedUser.last_name,
    is_registered:
      decoded.is_registered !== undefined
        ? decoded.is_registered
        : storedUser.is_registered,
    is_pwd_changed: isAzureSso
      ? true
      : decoded.is_pwd_changed !== undefined
        ? decoded.is_pwd_changed
        : storedUser.is_pwd_changed,
    userinfo: decoded.userinfo ?? storedUser.userinfo,
  };
});

export const updateUserInfo = createAction('update/userInfo');

export const resetUserInfo = createAction('reset/userInfo');

// User Login
export const userAccountLogin = createAsyncThunk('userLogin', async (data) => {
  const userlogin = await api.post('login', data);
  if (userlogin.status) {
    if (userlogin.status === 200) {
      let decoded = jwtDecode(userlogin.data.access);
      // if (decoded?.userinfo?.approve_status === 'new') {
      //   return {};
      // }
      localStorage.setItem('access_token', userlogin.data.access);
      localStorage.setItem('refresh_token', userlogin.data.refresh);
      return decoded;
    }
    if (userlogin.status === 401) {
      userlogin.error = 'Invalid Credentials';
    }
  }
  return userlogin;
});

// Get User Token
export const userAccessToken = createAsyncThunk(
  'refreshUserToken',
  async (data) => {
    const userToken = await api.post('/token/', data);
    if (userToken.status && userToken.status === 200) {
      localStorage.setItem('access_token', userToken.data.access);
      localStorage.setItem('refresh_token', userToken.data.refresh);
      let decoded = jwtDecode(userToken.data.access);
      return decoded;
    }
    return userToken;
  }
);

// Update User Role
export const updateUserRole = createAsyncThunk(
  'updateUserRole',
  async (data) => {
    const updateRole = await api.post('update-role', data);
    if (updateRole.status && updateRole.status === 200) {
      localStorage.setItem('access_token', updateRole.data.access);
      localStorage.setItem('refresh_token', updateRole.data.refresh);
      let decoded = jwtDecode(updateRole.data.access);
      return decoded;
    }
    return {
      ...updateRole,
    };
  }
);

// Forgot password
export const forgotPassword = createAsyncThunk(
  'userTriggerOtp',
  async (data) => {
    const triggerOtp = await api.post('trigger-otp', data);
    
    if (triggerOtp.status === 200) {
      return triggerOtp;
    }
    if (triggerOtp.status === 500) {
      return {
        ...triggerOtp,
        error: 'Server error',
      };
    }
    if (triggerOtp.status === 429) {
      return {
        ...triggerOtp,
        error: 'Error',
      };
    }
    if (triggerOtp.status === 401) {
      return {
        ...triggerOtp,
        error: triggerOtp?.message || 'Invalid Email',
      };
    }
    return triggerOtp;
  }
);

// Validate OTP
export const validateOTP = createAsyncThunk(
  'userValidateOTP',
  async (data, { rejectWithValue }) => {
    try {
      const validateOTP = await api.post('validate-otp', { ...data }, {
        withCredentials: true,
      });

      if (validateOTP.status === 200) {
        return validateOTP;
      }

      return validateOTP;
    } catch (error) {
      const backendData = error?.response?.data || {};
      return rejectWithValue({
        message:
          backendData.message ||
          backendData.error ||
          error?.message ||
          'OTP validation failed.',
        ...backendData,
      });
    }
  },
);

/**
 * Checks whether the password-reset cookie session is still valid.
 * Backend: GET /api/password-reset/session (reads pwd_reset_token cookie).
 * @returns {Promise<boolean>}
 */
export const checkPasswordResetSession = async () => {
  try {
    const response = await api.get("password-reset-session", {
      withCredentials: true,
    });
    return response?.status === 200 && response?.data?.valid === true;
  } catch {
    return false;
  }
};

// Validate OTP
export const updatePassword = createAsyncThunk(
  'userUpdatePassword',
  async (data,{ rejectWithValue }) => {
    try {
    const updatePassword = await api.post('update-pwd', { ...data}, { withCredentials: true,});
    if (updatePassword.status === 200) {
      return updatePassword;
    }
   }
    catch (error) {
      return rejectWithValue(
        error.response?.data || { error: "Something went wrong" }
      );
   } 
  }
);

// Update Questions
export const updateQuestions = createAsyncThunk(
  'userUpdateQuestions',
  async (data) => {
 
      const updateQuestion = await api.put('user_info_update', data);
      if (updateQuestion.status === 200&&updateQuestion?.data?.access) {
        let decoded = jwtDecode(updateQuestion.data.access);
        localStorage.setItem('access_token', updateQuestion.data.access);
        localStorage.setItem('refresh_token', updateQuestion.data.refresh);
        console.log(decoded,"decoded")
        return decoded;
      }
      return updateQuestion;

  }
);
export const updateQuestionsPost = createAsyncThunk(
  'userUpdateQuestions',
  async (data,type) => {
   
      const updateQuestion = await api.post('user_info_update', data);
      if (updateQuestion.status === 201&&updateQuestion?.data?.access) {
        let decoded = jwtDecode(updateQuestion.data.access);
        localStorage.setItem('access_token', updateQuestion.data.access);
        localStorage.setItem('refresh_token', updateQuestion.data.refresh);
        return decoded;
      }
      return updateQuestion;
    }
);

// Update Mentee Questions
export const updateMenteeQuestions = createAsyncThunk(
  'userUpdateMenteeQuestions',
  async (data) => {
    const updateQuestion = await api.post('mentee_info_update', data);
    if (updateQuestion.status === 201) {
      let decoded = jwtDecode(updateQuestion.data.access);

      localStorage.setItem('access_token', updateQuestion.data.access);
      localStorage.setItem('refresh_token', updateQuestion.data.refresh);
      return decoded;
    }
    return updateQuestion;
  }
);
export const updatePutMenteeQuestions = createAsyncThunk(
  'userUpdateMenteeQuestions',
  async (data) => {
    const updateQuestion = await api.put('mentee_info_update', data);
    if (updateQuestion.status === 201) {
      let decoded = jwtDecode(updateQuestion.data.access);

      localStorage.setItem('access_token', updateQuestion.data.access);
      localStorage.setItem('refresh_token', updateQuestion.data.refresh);
      return decoded;
    }
    return updateQuestion;
  }
);

// export const updateMenteeDocument = createAsyncThunk(
//   "updateMenteeDocument",
//   async (data) => {
//     console.log(data)
//     const url = data?.id 
//     ? `user/documents?user_id=${data.id}` 
//     : 'user/documents';
//     const updateDocument = await api.post(url, data?.data);
//     if (updateDocument.status === 201 || updateDocument.status === 200) {
//       return updateDocument;
//     }
//     return updateDocument;
//   }
// );

export const updateMenteeQuestionform = createAsyncThunk(
  "updateMenteeQuestionform",
  async (data) => {
    const updateDocument = await api.post("/mentee_info_update/mentee/mentee_registration_form/", data);
    if (updateDocument.status === 201 || updateDocument.status === 200) {
      return updateDocument;
    }
    return updateDocument;
  }
);

export const updatePUTMenteeQuestionform = createAsyncThunk(
  "updateMenteeQuestionform",
  async ({data,id}) => {
    const updateDocument = await api.put(`/mentee_info_update/mentee/mentee_registration_form/${id}/`, data);
    if (updateDocument.status === 201 || updateDocument.status === 200) {
      return updateDocument;
    }
    return updateDocument;
  }
);

export const updateToken = createAsyncThunk('updateToken', async (data) => {
  const updateNewToken = await api.post('generate_new_token');
  if (updateNewToken.status === 201) {
    // localStorage.setItem('access_token', updateNewToken.data.access);
    // localStorage.setItem('refresh_token', updateNewToken.data.refresh);
  }
  return updateNewToken;
});

export const getMenteeAssessmentForm = createAsyncThunk('getMenteeAssessmentForm', async (id) => {
  const getMenteeAssessmentForm = await api.get(`mentee_info_update/assessment/user-assessment-form/${id}/`);
  return getMenteeAssessmentForm;
});

export const menteeUserAssessmentForm = createAsyncThunk('menteeUserAssessmentForm', async (data) => {
  const menteeUserAssessmentForm = await api.post('mentee_info_update/assessment/user-assessment-form/', data);
  return menteeUserAssessmentForm;
});

export const menteeSubmitAssesmentForm = createAsyncThunk('menteeSubmitAssesmentForm', async (id) => {
  const menteeSubmitAssesmentForm = await api.post(`mentee_info_update/mentee/mentee_registration_form/${id}/submitted/`);
  return menteeSubmitAssesmentForm;
});
